import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyAJ_s86LejAFS9p-plfJdGB3c89EE5i8Yc",
  authDomain: "fir-todo-d01e0.firebaseapp.com",
  projectId: "fir-todo-d01e0",
  storageBucket: "fir-todo-d01e0.appspot.com",
  messagingSenderId: "874014820786",
  appId: "1:874014820786:web:a635d3758960a9ad70bcab",
}
initializeApp(firebaseConfig)

const db = getFirestore()

export { db }
